import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import type { BookFormat } from '@lite-workspace/photobook-model';
import { DialogSheetComponent, dialogSheetHostClass } from '@lite-workspace/shared/helm-ui/dialog';
import type { CreateProjectDraftSnapshot } from '../domain/application/create-project-draft-stash.service';
import { CreateProjectFormComponent, type CreateProjectDraft } from './create-project-form.component';

export type { CreateProjectDraft } from './create-project-form.component';

/** The already-picked design pack's format family — it outranks the saved preference when they clash,
 *  else the dialog would preselect a product the pack cannot fit. */
export interface CreateProjectDialogContext {
  packFormat?: BookFormat | null;
  /** Стартовый выбор шаблона от вызывающего экрана; null — «Без шаблона». */
  designId?: string | null;
  /** Экран сам ведёт шаблон своим шагом (онбординг) — строка «Шаблон» на нём только врала бы: её
   *  выбор в проект не уезжает. Скрываем её целиком. */
  designRowHidden?: boolean;
  /** Возврат из раздела «Шаблоны»: модалка встаёт на оставленный черновик, а не на дефолты. */
  restore?: CreateProjectDraftSnapshot | null;
}

@Component({
  selector: 'app-create-project-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DialogSheetComponent, CreateProjectFormComponent],
  host: { '[class]': 'hostClass' },
  template: `
    <hlm-dialog-sheet>
      <ng-template>
        <h2 class="mb-5.5 text-xl font-semibold tracking-tight text-ink">{{ form.labHeading() ?? 'Создание проекта' }}</h2>
        <app-create-project-form
          #form
          chrome="sheet"
          [packFormat]="context?.packFormat ?? null"
          [initialDesignId]="context?.designId"
          [designRowHidden]="context?.designRowHidden ?? false"
          [restore]="context?.restore ?? null"
          (submitted)="close($event)"
          (cancelled)="close(undefined)"
        />
      </ng-template>
    </hlm-dialog-sheet>
  `,
})
export class CreateProjectDialogComponent {
  protected readonly hostClass = dialogSheetHostClass('project');
  private readonly dialogRef = inject(BrnDialogRef);
  protected readonly context = injectBrnDialogContext<CreateProjectDialogContext | undefined>({ optional: true });

  protected close(draft: CreateProjectDraft | undefined): void {
    this.dialogRef.close(draft);
  }
}
